module.exports = ".checkbox input{\n  margin-left: 1px;\n}\n\n\n.input-group{\n  margin-bottom: 5px;\n}\n\n\n.field-error-message{\n  margin-top: 5px;\n  color: red;\n}\n\n\n.field-label{\n  margin-top: 12px\n}\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/restaurant/restaurant-form/restaurant-form.component.css
// module id = ./src/app/restaurant/restaurant-form/restaurant-form.component.css
// module chunks = main